module.exports = __webpack_public_path__ + "img/Materiaux-de-decoration.2518970a.webp";